module.exports = __webpack_public_path__ + "img/code3_border.8e878150.jpg";